import { Component, OnInit, Input } from '@angular/core';
import { EventService } from 'src/app/events/services/event.service';
import { VehicleList } from 'src/app/vehicles/models/vehicle';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';

@Component({
  selector: 'app-user-events-config',
  templateUrl: './user-events-config.component.html',
  styleUrls: ['./user-events-config.component.scss', './../components-conf.scss']
})
export class UserEventsConfigComponent implements OnInit {
  @Input() filterOptionsBy: string = "";

  stateOptions: any[] = [
    { name: "Todos", value: "all" },
    { name: "Pendientes", value: "pending" },
    { name: "Evaluados", value: "evaluated" },
  ];

  vehiclesList: VehicleList[] = [];
  public filterConfiguration = "";
  public configSections = configSections;

  operations: any[] = [];
  selectedOperation: any;
  groups: any[] = [];
  selectedGroup: any;
  convoys: any[] = [];
  selectedConvoy: any;

  placeholderOperation = 'Seleccione una Operación...';
  placeholderGroup = 'Seleccione una Operación Primero...';
  placeholderConvoy = 'Seleccione un Grupo Primero...';

  disabledOperation = false;
  disabledGroup = true;
  disabledConvoy = true;

  public selectedColumns: any[] = [];

  constructor(
    public eventService: EventService,
    public vehicleService: VehicleService
  ) { }

  async ngOnInit(): Promise<void> {
    this.selectedOperation = this.eventService.config.selectedOperation;
    this.selectedGroup = this.eventService.config.selectedGroup;
    this.selectedConvoy = this.eventService.config.selectedConvoy;

    this.updateDropdowns(false); // Initialize without overwriting selected vehicles
  }

  /**
   * Updates dropdown options based on the currently selected cascaded fields.
   * If resetSelection is true, the `vehiclesSelected` reflects the full new list.
   */
  updateDropdowns(resetSelection: boolean = true) {
    const allVehicles = this.vehicleService.vehicles || [];

    // 1. Operations are always computed from all vehicles
    this.operations = this.getUniqueOptions(allVehicles, 'idoperation', ['nameoperation', 'operation']);
    this.disabledOperation = false;

    // 2. Filter step 1: by Operation
    let vehiclesFilteredByOp = allVehicles;
    if (this.selectedOperation != null) {
      vehiclesFilteredByOp = allVehicles.filter(v => v.idoperation === this.selectedOperation);

      this.groups = this.getUniqueOptions(vehiclesFilteredByOp, 'idgrupo', ['namegrupo', 'grupo']);
      this.disabledGroup = false;
      this.placeholderGroup = 'Seleccione un Grupo...';
    } else {
      this.groups = [];
      this.selectedGroup = null;
      this.disabledGroup = true;
      this.placeholderGroup = 'Seleccione una Operación Primero...';
    }

    // 3. Filter step 2: by Group
    let vehiclesFilteredByGroup = vehiclesFilteredByOp;
    if (this.selectedGroup != null) {
      vehiclesFilteredByGroup = vehiclesFilteredByOp.filter(v => v.idgrupo === this.selectedGroup);

      this.convoys = this.getUniqueOptions(vehiclesFilteredByGroup, 'idconvoy', ['nameconvoy']);
      this.disabledConvoy = false;
      this.placeholderConvoy = 'Seleccione un Convoy...';
    } else {
      this.convoys = [];
      this.selectedConvoy = null;
      this.disabledConvoy = true;
      this.placeholderConvoy = 'Seleccione un Grupo Primero...';
    }

    // 4. Filter step 3: by Convoy
    let finalFilteredVehicles = vehiclesFilteredByGroup;
    if (this.selectedConvoy != null) {
      finalFilteredVehicles = vehiclesFilteredByGroup.filter(v => v.idconvoy === this.selectedConvoy);
    }

    // 5. Update the available vehicles list
    this.populateVehiclesList(finalFilteredVehicles);

    if (resetSelection) {
      this.eventService.config.vehiclesSelected = [...this.vehiclesList];
    }

    // 6. Push state update upstream if applicable
    if (this.eventService.setOperationSelected) this.eventService.setOperationSelected(this.selectedOperation);
    if (this.eventService.setGroupSelected) this.eventService.setGroupSelected(this.selectedGroup);
    if (this.eventService.setConvoySelected) this.eventService.setConvoySelected(this.selectedConvoy);
  }

  onChangeOperation() {
    this.selectedGroup = null;
    this.selectedConvoy = null;
    this.updateDropdowns(true);
  }

  onChangeGroup() {
    this.selectedConvoy = null;
    this.updateDropdowns(true);
  }

  onChangeConvoy() {
    this.updateDropdowns(true);
  }

  private getUniqueOptions(vehicles: any[], idKey: string, nameKeys: string[]) {
    const uniqueMap = new Map();
    for (const v of vehicles) {
      const id = v[idKey];
      if (id != null && !uniqueMap.has(id)) {
        let name = '';
        for (const key of nameKeys) {
          if (v[key]) {
            name = v[key];
            break;
          }
        }
        uniqueMap.set(id, { [idKey]: id, [nameKeys[0]]: name });
      }
    }
    return Array.from(uniqueMap.values()).sort((a, b) => (a[idKey] || 0) - (b[idKey] || 0));
  }

  private populateVehiclesList(source: any[]) {
    this.vehiclesList = source.map(vh => ({
      id: vh.id!,
      plate_number: vh.plate_number!,
      IMEI: vh.IMEI!,
      cod_interno: vh.cod_interno!,
      name: (vh as any).name_old || vh.name_old || vh.name!,
      idoperation: vh.idoperation,
      nameoperation: (vh as any).nameoperation || vh.operation,
      idgrupo: vh.idgrupo,
      namegrupo: (vh as any).namegrupo || vh.grupo,
      idconvoy: vh.idconvoy,
      nameconvoy: vh.nameconvoy
    }));
  }
}
